import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
//import FlujogramaBaseScreen from "./FlujogramaBaseScreen.js";
import { Typography } from "@material-ui/core";
import styles from "assets/jss/flujogramaScreenstyle.js";
import { useLocation,  useParams } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Select from '@material-ui/core/Select';
import YoutubeEmbed from "components/general/YoutubeEmbed";
import BaseScreen from "./BaseScreen";

const useStyles = makeStyles(styles);

export default function FlujogramaScreen(props) {
    let { year } = useParams();
    let thisYear = new Date().getFullYear();
    //const rootRef = React.useRef(null);
    const location = useLocation();
    const classes = useStyles();
    //const [pageObject, setPageObject] = React.useState({ isLoading: true, data: { title: '...' } });
    let imageFlujograma = "/history/FLUJOGRAMA" + year.toString() + ".svg";
    const fullScreenHandle = useFullScreenHandle();
    useEffect(() => {

    }
        , [location]);
    const handleChange = (e) => {
        console.log("changed", e);
        props.history.push("/flujograma/flujograma/" + e.target.value);
    };
    if ((year < 2014) || (year >= (thisYear))) props.history.push("/notfound");
    return (
        <BaseScreen primaryHeader bodyColor="#f2f3f6">
            <Grid container>
                <Grid item xs={12} sm={12} md={12} className={classes.divisoryClass}>
                    <Typography variant="h1" className={classes.title}>
                        Flujograma
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={8}>
                    <div className={classes.graphOptionsMenuContainer}>
                        <div className={classes.graphOptionsMenuContainerTitle}>
                            <Typography variant="h2" className={classes.emphasizedHeader}>Año</Typography>
                            <Select
                                native
                                value={year}
                                onChange={handleChange}

                                inputProps={{
                                    name: 'anio',
                                    id: 'outlined-year-native-simple',
                                }}
                                disableUnderline 
                               style={{ paddingBottom: '5px', paddingLeft: '10px' }}
                            >
                                <option value={2014}>2014</option>
                                <option value={2015}>2015</option>
                                <option value={2016}>2016</option>
                                <option value={2017}>2017</option>
                                <option value={2018}>2018</option>
                                <option value={2019}>2019</option>
                                <option value={2020}>2020</option>
                                <option value={2021}>2021</option>
                                <option value={2022}>2022</option>
                                <option value={2023}>2023</option>
                                <option value={2024}>2024</option>
                            </Select>
                        </div>
                        <div className={classes.graphOptionsMenuButton} onClick={fullScreenHandle.enter}>
                            <div className={classes.graphOptionsMenuIcon}>
                                <i class="fas fa-expand"></i>
                            </div>
                            <Typography variant="subtitle2">Expandir</Typography>
                        </div>
                    </div>
                    <div className={classes.flujogramaImageContainer}>
                        <FullScreen handle={fullScreenHandle}>
                            <img src={imageFlujograma} className={classes.svgImage} alt='Flujograma de la Justicia Criminal'/>
                        </FullScreen>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={4} className={classes.rightContentContainer}>
                        <div className={classes.rightSideTextContainer}> 

                                <YoutubeEmbed embedId="pip5vlZcAoU" />
                        </div>
                </Grid>
            </Grid>

        </BaseScreen>
    )
}
